module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/gifts/gift_blue_01-4a5eed481fb8ba77bb702bb5e4e752ae.svg";